import React from "react";
import Head from "./head";
//import { useLocation } from "react-router-dom";
import Bio from "./bio";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WhatIDo from "./whatido";
import Portfolio from "./portfolio";
import Skills from "./skills";
import ContactUs from "./contactus";
import Footer from "./footer";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";


function Home(){

    const [isPageScrolled, setIsPageScrolled] = React.useState(false);
    const [activeMenu, setActiveMenu] = React.useState('bio');
    const [isLightMode, setIsLightMode] = React.useState(false);
    const sectionRefs = React.useRef([]);


    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',  
      });
    }

    // Function to assign a ref
    const setSectionRef = (idx) => (el) => {
      sectionRefs.current[idx] = el;
    }

    const navigateToMenu = (id,section) =>{
      sectionRefs.current[id].scrollIntoView({
        behavior:"smooth",
      });
      setActiveMenu(section);
    }

    React.useEffect(()=>{
        const handleScroll = () =>{
                const firstSectionHeight = (document.getElementById('bio').offsetHeight);
                let scrollPosition = window.scrollY;
                const headerSticky = firstSectionHeight / 4;
                if(scrollPosition > headerSticky){
                  setIsPageScrolled(true);
                } else {
                  setIsPageScrolled(false);
                }
                const sections = document.querySelectorAll('section[id]');
                sections.forEach((sect) => {
                  const rect = sect.getBoundingClientRect();
                  const isInView = rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2;
                  if(isInView){
                      setActiveMenu(sect.id);
                  }
                })
        };
        
        window.addEventListener('scroll', handleScroll);
        // Cleanup the event listener
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
        
    },[]);

    return(
        <>
        <div className={` ${isLightMode ? 'bg-gray-100':'bg-gray-800'} transition-colors duration-300 z-0`} rel="noreferrer">
            <Head isScrolled={isPageScrolled} activeMenu={activeMenu} navigateMenu={navigateToMenu} lightMode={isLightMode} setLightMode={setIsLightMode} />
        <main id="main_nizudev" className="snap-y snap-mandatory scroll-smooth">
            <div className="p-5 md:p-7 snap-start">  
                <section id="bio" ref={setSectionRef(0)} className={` ${isLightMode ? "custom-bio-bg-light":"custom-bio-bg"} rounded-2xl`}>           
                    {/* Bio Section */}
                    <Bio lightMode={isLightMode}/>
                </section>
            </div>
                
            <section id="what-i-do" ref={setSectionRef(1)} className={` ${isLightMode ? "bg-gray-100":"bg-gray-800"}  min-h-screen snap-start`}>
                {/* What i Do Section */}
                <WhatIDo lightMode={isLightMode} />
            </section>
            <section id="portfolio" ref={setSectionRef(2)} className="bg-gray-900 snap-start">
                <Portfolio lightMode={isLightMode} />
                
            </section>
            <section id="skills" ref={setSectionRef(3)} className="snap-start">
                <Skills lightMode={isLightMode}/>
            </section>
            <section id="contact_us" ref={setSectionRef(4)} className="snap-start">
              <ContactUs lightMode={isLightMode}/>
           
            </section>
            <button onClick={scrollToTop} className={`flex justify-center items-center fixed bottom-8 right-8 p-3 border-2 border-solid border-[#FC0449] rounded-full third-color transform ${isPageScrolled ? 'scale-1 ' :'scale-0'}  transition-all duration-200 ease-linear hover:bg-[#FC0449] hover:text-black`}><FontAwesomeIcon className="w-5 h-5" icon={faAngleUp} /></button>
            <div className="footer-area snap-start">
                <Footer lightMode={isLightMode}/>
            </div>
            
        </main>
        </div>
        </>
    );
}

export default Home;